"use client";

import { useState } from "react";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { Icon } from "@/components/ui/Icon";

export function Faq({ items, id = "faq" }: { items: { q: string; a: string }[]; id?: string }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id={id} className="relative py-24 md:py-32">
      <div className="container-page">
        <SectionHeading
          eyebrow="FAQ"
          title={<>Häufige Fragen</>}
          subtitle="Noch etwas offen? Schreiben Sie uns. Sie bekommen eine ehrliche Antwort, auch wenn sie gegen einen Auftrag spricht."
        />

        <div className="mx-auto mt-12 max-w-3xl">
          <ul className="flex flex-col gap-3">
            {items.map((item, i) => {
              const isOpen = open === i;
              return (
                <li key={item.q} className="card overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="font-semibold text-fg">{item.q}</span>
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full bg-surface-2 text-brand-ink transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <Icon name="chevron-down" size={18} />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 leading-relaxed text-fg-muted">{item.a}</p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
